<template>
  <div class="aboutPage">
    <div class="jojo_about">
      <div>
        <div>What is JoJoWorld?</div>
        <div style="text-align: center;">
          <p>JoJoWorld is a decentralized, AI-driven platform dedicated to transforming the way AI companies access and leverage high-quality spatial 3D data. As a critical provider of spatial 3D data, JoJoWorld supports cutting-edge foundation models such as training</p>
          <p style="font-weight: bold;">Text-to-3D models and enabling embodied robotics.</p>
<!--          <p>Headquartered in New York, JoJoWorld has been recognized by NVIDIA's prestigious startup accelerator program and collaborates with global leaders like Google, NVIDIA, and Microsoft.</p>-->
          <p>Headquartered in New York, JoJoWorld has been honored to be selected for the startup programs of global leaders NVIDIA and Microsoft.</p>
          <p>Our AI team is composed of experts hailing from world-renowned institutions, including Stanford, MIT, and Carnegie Mellon.</p>
          <p>By bridging the gap between spatial 3D data and AI development, JoJoWorld is driving innovation and making 3D content more accessible and impactful across industries.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  data () {
    return {
    }
  },
  mounted () {
  },
   components: {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

@media (max-width: 767px) {

 .jojo_about {
   background:url("../assets/H5_about_bg.png");
   position:absolute;
   top:0px;
   width:100%;
   height:100%;
   overflow-y:auto;
   >div:nth-child(1) {
      padding:95px 10% 42px;
      >div:nth-child(1) {
        color: #FFF;
        text-align: center;
        text-shadow: 0px 1.54px 3px rgba(0, 0, 0, 0.30);
        font-size: 22px;
        font-style: normal;
        font-weight: 700;
        line-height: 128%;
      }
      >div:nth-child(2) {
        p {
          margin-top:12px;
          color: #E5E5E5;
          text-align: center;
          text-shadow: 0px 1.54px 3px rgba(0, 0, 0, 0.30);
          font-size: 13px;
          font-style: normal;
          font-weight: 500;
          line-height: 22px;
        }
      }
   }
 }
}
@media (min-width: 767px) {
  .aboutPage {
     width:100%;
       height:calc(~"100% - 135px");
      background:url("../assets/web_bg1.png") no-repeat;
      background-position: center;
  }
  .jojo_about {
    width:770px;
    margin:auto;
    left:50%;
    transform: translateX(-50%);
    position:absolute;
    z-index:2;
    >div:nth-child(1) {
      margin-top:67px;

      >div:nth-child(1) {
      font-family: "EncodeSans-Bold";
        font-size: 24px;
        line-height: 34px;
        color: #FFFFFF;
        text-align: center;
        padding-top:70px;
      }
      >div:nth-child(2) {
        font-size:15px;
        margin-top:40px;
        p {
          margin-top:0;
          margin-bottom:30px;
          font-size: 18px;
          line-height: 34px;
        }
        margin-bottom:132px;
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/About.vue